<template>
  <base-modal ref="modal" size="4xl">
    <base-card>
      <div class="tw-text-xl tw-font-thin tw-border-b tw-pb-3">{{ title }}</div>
      <p class="tw-font-thin tw-mt-5">{{ prompt }}</p>
      <base-tabs class="tw-mt-4" :key="selectedPlans.length">
        <base-tab v-for="(plan, index) in selectedPlans" :key="plan.businessPlanId" :selected="!index" :title="plan.name">
          <BusinessPlanAgreement
            :business-plan-id="plan.businessId"
            :price-cents="plan.priceCents"
            :currency="plan.priceCurrency"
            :down-payment-cents="plan.downPaymentCents"
            :business-name="organization.description"
            :term-length="plan.termLength"
            :term-interval="plan.termInterval"
            :cycle-frequency="plan.billingFrequency"
            :cycle-interval="plan.billingInterval"
            :service-fee-cents="plan.serviceFeeCents"
            class="tw-mt-3"
          />
        </base-tab>
      </base-tabs>
      <p class="tw-font-thin tw-mt-2">
        I agree to these Member Plan Terms and Conditions. I also agree to the Member Terms of Service and I acknowledge the Privacy Policy.
      </p>
      <div class="tw-mt-3">
        <a class="tw-mr-6 tw-text-primary" href="https://www.predictile.com/member-terms-of-service/index.html" target="_blank">Member Terms of Service</a>
        <a class="tw-text-primary" href="https://www.predictile.com/privacy-policy/index.html" target="_blank">Privacy Policy</a>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="accept" :loading="loading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3 tw-z-100">Accept</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import BusinessPlanAgreement from "@/views/business/business-plans/components/BusinessPlanAgreement";

import { mapGetters } from "vuex";
import { capitalize } from "lodash";

export default {
  components: {
    BusinessPlanAgreement,
  },
  props: {
    selectedPlans: Array,
    loading: Boolean,
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
    title() {
      return `${capitalize(this.organization.customerLabelSingular)} Terms Acceptance`;
    },
    prompt() {
      return `Please have the ${this.organization.customerLabelSingular} agree to the plan Terms and Conditions`;
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    accept() {
      this.$emit("accepted");
    },
  },
};
</script>
